import React from "react";

const FlexSpacer = () => {
    return (
        <div className="l-flex-spacer" />
    );
};

export default FlexSpacer;